<script>
import EditFieldModal from './EditFieldModal.vue';

export default {
  components: {
    EditFieldModal,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    description: {
      type: String,
      default: '',
    },
    descriptionMobile: {
      type: String,
      default: '',
    },
  },
  emits: ['close', 'save', 'delete'],
  computed: {
    hasContent() {
      return !!this.description;
    },
    fields() {
      return [
        {
          key: 'description',
          label: 'Description (Desktop)',
          placeholder: 'Enter description for desktop',
          value: this.description,
          type: 'textarea',
          rows: 4,
        },
        {
          key: 'descriptionMobile',
          label: 'Description (Mobile)',
          placeholder: 'Enter description for mobile',
          value: this.descriptionMobile,
          type: 'textarea',
          rows: 4,
        },
      ];
    },
  },
  methods: {
    handleSave(values) {
      this.$emit('save', values);
    },
    handleClose() {
      this.$emit('close');
    },
    handleDelete() {
      this.$emit('delete');
    },
  },
};
</script>

<template>
  <EditFieldModal
    :visible="visible"
    modal-title="Edit Description"
    modal-width="600px"
    :fields="fields"
    :show-delete="hasContent"
    @save="handleSave"
    @close="handleClose"
    @delete="handleDelete"
  />
</template>
